module.exports = __webpack_public_path__ + "static/about-two-small-910e5f0294d773773aac0e4f6799111b.jpg";